import React, { useImperativeHandle } from 'react';
import { Form } from '@whalecloud/fdx';
import { DeviceFormItem } from '@/components';

const ExpandeForm = props => {
  const { modelKey, form, initialValue, extraFormItems = {}, refInstance, activeGoodsPanels, onCollapseChange, tabKey } = props;

  useImperativeHandle(refInstance, () => ({
    validateFields: async () => {
      await form.validateFields((err, value) => {
        if (err) {
          activeGoodsPanels.push(tabKey); // 校验不通过，需要自动将这个不通过的折叠面板展开
          onCollapseChange([...new Set(activeGoodsPanels)]) // 去重
        }
      });
    },
  }));
  return (
    <Form layout="inline">
      <DeviceFormItem
        modelKey={modelKey}
        form={form}
        initialValue={initialValue}
        extraFormItems={extraFormItems}
      />
    </Form>
  );
};

const Component = Form.create({
  onValuesChange: (props, changedValues) => {
    props.onChange(changedValues);
  },
})(ExpandeForm);

export default React.forwardRef((props, ref) => <Component {...props} refInstance={ref} />);
